import script from "./ModalAgregarPairing.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalAgregarPairing.vue?vue&type=script&setup=true&lang=ts"

import "./ModalAgregarPairing.vue?vue&type=style&index=0&id=8cd6a8ea&lang=css"

const __exports__ = script;

export default __exports__